<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">商品管理</li>
      </ol>
    </div>
    <div class="content-operator content-border">
      <el-button type="primary" @click="saveGoodsSaleStatus('ONLINE')" size="small">批量上架</el-button>
      <el-button type="primary" @click="saveGoodsSaleStatus('OFFLINE')" size="small">批量下架</el-button>
      <el-button type="primary" @click="saveGoodsSaleStatus('PRE_SALE')" size="small">批量预售</el-button>
      <el-button type="primary" size="small"
                 @click="$common.goRouterLink({ name: 'goodsDetail', query: { spaceType: query.spaceType,spaceType:'SOLID' }})">
        添加
      </el-button>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="一级分类：">
          <el-select v-model="goodsTypeIdOne" clearable @change="goodsTypeOneChange">
            <el-option v-for="(item, index) in goodsTypeOnes" :key="index" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类：">
          <el-select v-model="goodsTypeIdTwo" clearable>
            <el-option v-for="(item, index) in goodsTypeTwos" :key="index" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售状态：">
          <el-select v-model="query.saleStatus" clearable><!-- v-if="'WAREGOUSE'!=item.name" -->
            <el-option v-for="(item, index) in saleStatuses" :key="index" :label="item.label"
                       :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库：">
          <el-select v-model="query.sellerId" clearable>
            <el-option v-for="(item, index) in sellers" :key="index" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="　关键词：">
          <el-input placeholder="请输入关键词" v-model="query.keyword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>商品列表</span>
    </div>
    <div class="content-data" v-if="goodses && 0 < goodses.length">
      <el-table highlight-current-row :data="goodses" border ref="multipleTable"
                @selection-change="handleSelectionChange">
        <el-table-column align="center" type="index"/>
        <el-table-column align="center" type="selection"/>
        <el-table-column align="center" label="图片">
          <template slot-scope="scope">
            <el-image style="height: 100px; width: 100px;" :src="dynamicPath+scope.row.iconPath">
              <div slot="error" class="image-slot">
                <el-image title="加载失败"
                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png"/>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="名称" prop="name"/>
        <el-table-column align="center" label="销售状态">
          <template slot-scope="scope">
            <el-tag
                :type="scope.row.saleStatus==='OFFLINE'?'danger'
                :scope.row.saleStatus==='ONLINE'?'success'
                :scope.row.saleStatus==='PRE_SALE'?'info'
                :'warning'"
                effect="dark">
              {{ saleStatusMap[scope.row.saleStatus] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="售价" >
          <template slot-scope="scope">
            ￥{{ scope.row.price}}
          </template>
        </el-table-column>
        <el-table-column align="center" label="成本价" >
          <template slot-scope="scope">
            ￥{{ scope.row.costPrice}}
          </template>
        </el-table-column>
        <el-table-column align="center" label="库存" prop="stockAmount"/>
        <el-table-column align="center" fixed="right" label="操作" width="250px">
          <template slot-scope="scope">
            <el-tooltip content="修改" placement="top"
                        effect="light">
              <el-button type="primary" size="mini" round icon="el-icon-setting"
                         @click="$common.goRouterLink({ name: 'goodsDetail', query: { goodsId: scope.row.id }})"/>
            </el-tooltip>

            <el-tooltip content="删除" placement="top"
                        effect="light">
              <el-button type="danger" @click="deleteGoods(scope.row.id)" size="mini"
                         icon="el-icon-delete" el-icon-delete round/>
            </el-tooltip>

            <el-popover
                trigger="click"
                placement="top"
                visible-arrow="false"
            >
              <div style="text-align: center">
                <el-tooltip content="下架" placement="top" effect="light">
                  <el-button type="danger" @click="clickeSaveSaleStatus(scope.row.id,'OFFLINE')" size="mini" round>
                    <svg-icon icon-class="offline"/>
                    下架
                  </el-button>
                </el-tooltip>
                <el-tooltip content="立即上架" placement="top" effect="light">
                  <el-button type="primary"
                             @click="clickeSaveSaleStatus(scope.row.id,'ONLINE')" size="mini" round>
                    <svg-icon icon-class="online"/>
                    上架
                  </el-button>
                </el-tooltip>
                <el-tooltip content="预售" placement="top" effect="light">
                  <el-button type="success"
                             @click="clickeSaveSaleStatus(scope.row.id,'PRE_SALE')" size="mini" round>
                    <svg-icon icon-class="pre-sale"/>
                    预售
                  </el-button>
                </el-tooltip>
              </div>
              <el-tooltip slot="reference" style="margin-left: 10px" content="修改销售状态" placement="top" effect="light">
                <el-button type="primary" size="mini" round>
                  <svg-icon icon-class="shopping-cart"/>
                </el-button>
              </el-tooltip>
            </el-popover>

            <el-popover
                trigger="click"
                placement="top"
                visible-arrow="false"
            >
              <div style="text-align: center">
                <el-tooltip v-if="0===scope.row.isRecommendAdmin"
                            content="推荐" placement="top"
                            effect="light">
                  <el-button type="primary" icon="el-icon-star-off"
                             @click="setIsRecommendAdmin(scope.row,1)" size="mini" round>
                    推荐
                  </el-button>
                </el-tooltip>
                <el-tooltip v-else-if=" 1===scope.row.isRecommendAdmin"
                            content="取消推荐" placement="top"
                            effect="light">
                  <el-button icon="el-icon-star-off" type="danger" @click="setIsRecommendAdmin(scope.row,0)"
                             size="mini" round>
                    取消推荐
                  </el-button>
                </el-tooltip>
                <el-tooltip content="添加到活动中心" placement="top"
                            effect="light">
                  <el-dropdown @command="handleCommand" trigger="click">
                    <el-button type="success" @click="findActivity(scope.row.id)" size="mini"
                               icon="el-icon-plus" round>
                      添加到活动
                    </el-button>
                    <el-dropdown-menu v-if="addActivityes&&addActivityes.length>0" slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in addActivityes" :key="index"
                                        :command="beforeHandleCommand(item.id,scope.row.id)">
                        {{ item.mainTitle }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                    <el-dropdown-menu v-else slot="dropdown">
                      <el-dropdown-item>暂无可添加推荐</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-tooltip>
                <el-tooltip content="复制小程序路径" placement="top"
                            effect="light">
                  <el-button type="info" icon="el-icon-copy-document"
                             v-clipboard:copy="'pages/commoditybox/commodityDetails/index?goodsId='+scope.row.id"
                             v-clipboard:success="onCopy"
                             v-clipboard:error="onError" size="mini" round/>
                </el-tooltip>
              </div>
              <el-tooltip slot="reference" style="margin-left: 10px" content="更多" placement="top" effect="light">
                <el-button type="warning" size="mini" round>
                  <svg-icon icon-class="other"/>
                </el-button>
              </el-tooltip>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-data" v-else>
      没有查询到数据
    </div>
    <vue-pager v-bind:datafile="fillData" url="goods/pageGoodsByManager" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
    <save-activity-goods ref="save-activity-goods"/>
  </div>
</template>
<script>

import SaveActivityGoods from "@/views/goods/components/save-activity-goods.vue"

export default {
  components: {SaveActivityGoods},
  data() {
    return {

      visible: false,

      sellers: [],
      goodsTypeIdOne: '',
      goodsTypeOnes: [],
      goodsTypeIdTwo: '',
      goodsTypeTwos: [],

      goodses: [],
      checkStatuses: [],
      checkStatusMap: {},
      saleStatuses: [],
      saleStatusMap: {},
      assetTypes: [],
      assetTypeMap: {},

      query: {},

      checkInputs: [],

      spaceTypeMap: {},

      dynamicPath: config.dynamicResourcePath,
      multipleSelection: [],
      addActivityes: [],

    }
  },
  created() {
    var _this = this;
    _this.saleStatuses = _this.$common.enum_config('EGoodsSaleStatus');
    _this.saleStatuses && _this.saleStatuses.forEach((item) => {
      _this.saleStatusMap[item.name] = item.label;
    });
    _this.findGoodsTypeOne();
    _this.findSeller();
  },
  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    },
    beforeHandleCommand(activityId, goodsId) {
      return {
        'activityId': activityId,
        'goodsId': goodsId
      }
    },
    findActivity(_id) {
      var _this = this;
      _this.addActivityes = [];
      if (_id) {
        _this.$common.my_ajax({
          url: 'activity/pageActivity',
          data: {
            limit: -1,
            goodsId: _id
          },
          success: function (response) {
            _this.addActivityes = response.items;
          }
        });
      }
    },
    handleCommand(command) {
      let _this = this;
      _this.$refs["save-activity-goods"].open({activityId: command.activityId, goodsId: command.goodsId})
    },
    handleSelectionChange(val) {
      this.checkInputs = val;
    },
    clickeSaveSaveWarehouse(_goodsIds) {
      var goodsIds = [];
      goodsIds.push(_goodsIds);
      this.saveWarehouse(goodsIds);
    },
    saveWarehouse(_goodsIds) {
      var _this = this;
      _this.$common.my_ajax({
        url: 'goods/saveWarehouse',
        data: {
          goodsIds: _goodsIds,
          saleStatus: 'WAREGOUSE'
        },
        contentType: 'application/json',
        success: function (response) {
          _this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            onClose() {
              _this.submitQuery(_this.query.current);
            }
          });
        }
      });
    },
    setIsRecommendAdmin(_goods, _isRecommendAdmin) {
      var _this = this;
      _this.$common.my_ajax({
        url: 'goods/setIsRecommendAdmin',
        data: {
          goodsId: _goods.id,
          isRecommendAdmin: _isRecommendAdmin
        },
        success: function (response) {
          _this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            onClose() {
              _this.$set(_goods, 'isRecommendAdmin', _isRecommendAdmin);
            }
          });
        }
      });
    },
    deleteGoods(_goodsId) {
      var _this = this;
      _this.$common.my_ajax({
        url: 'goods/deleteGoods',
        data: {
          goodsId: _goodsId
        },
        success: function (response) {
          _this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
            onClose: function () {
              _this.submitQuery(_this.query.current);
            }
          });
        }
      });
    },
    fillData(response) {
      this.goodses = response.items || [];
    },
    submitQuery(_num) {
      var _this = this;
      _this.goodses = [];
      _this.$set(_this.query, 'goodsTypeId', _this.goodsTypeIdTwo || _this.goodsTypeIdOne);
      _this.$refs.pager.gotoPage(_num);
    },
    findGoodsTypeOne() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'goodsType/pageGoodsTypeByManager',
        data: {
          level: 1
        },
        success: function (response) {
          _this.goodsTypeOnes = response.items;
        }
      });
    },
    findSeller() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'seller/pageSeller',
        data: {
          limit: -1
        },
        success: function (response) {
          _this.sellers = response.items;
        }
      });
    },
    goodsTypeOneChange() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'goodsType/pageGoodsTypeByManager',
        data: {
          parentTypeId: _this.goodsTypeIdOne
        },
        success: function (response) {
          _this.goodsTypeTwos = response.items;
          _this.goodsTypeIdTwo = '';
        }
      });
    },
    saveGoodsSaleStatus(_saleStatus) {
      var _this = this;
      if (0 === _this.checkInputs.length) {
        _this.$message({
          type: 'error',
          message: '请先选择数据',
          duration: 1000,
        });
        return false;
      }
      var goodsIds = [];
      for (var i = 0; i < _this.checkInputs.length; i++) {
        var checkInput = _this.checkInputs[i];
        goodsIds.push(checkInput.id);
      }
      _this.saveSaleStatus(goodsIds, _saleStatus);
    },
    clickeSaveSaleStatus(_goodsIds, _saleStatus) {
      var goodsIds = [];
      goodsIds.push(_goodsIds);
      this.saveSaleStatus(goodsIds, _saleStatus);
    },
    saveSaleStatus(_goodsIds, _saleStatus) {
      var _this = this;
      _this.$common.my_ajax({
        url: 'goods/saveSaleStatus',
        data: {
          goodsIds: _goodsIds,
          saleStatus: _saleStatus
        },
        contentType: 'application/json',
        success: function (response) {
          _this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
            onClose() {
              _this.submitQuery(1);
            }
          });
        }
      });
    },
  },
  watch: {
    '$route'(to, from) {
      var _this = this;
      if (to.name == from.name) {
        _this.query = {};
        _this.$set(_this.query, 'spaceType', _this.$route.query.spaceType);

        _this.goodses = [];
        _this.$nextTick(function () {
          _this.$refs.pager.gotoPage();
        });
      }
    }
  },
}
</script>
<style scoped>
.el-dropdown {
  margin: 10px;
}
</style>
